// extracted by mini-css-extract-plugin
export default {"Tooltip":"_Tooltip--S7yfK"};